import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import QuotePdf from "../components/quote/QuotePdf";
import html2pdf from "html2pdf.js";
import { Box, Button, CircularProgress, Stack } from "@mui/material";

export default function PdfPreview() {
  const navigate = useNavigate();
  const { state } = useLocation(); // { data, lead }
  const htmlRef = useRef(null); // mini-preview oculta
  const [blobUrl, setUrl] = useState("");

  /* Genera el PDF (una sola vez) */
  useEffect(() => {
    if (!state?.data || !htmlRef.current) return;

    html2pdf()
      .from(htmlRef.current)
      .set({
        margin: 0,
        html2canvas: { scale: 2, useCORS: true },
        jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
      })
      .outputPdf("blob")
      .then((blob) => setUrl(URL.createObjectURL(blob)));
  }, [state]);

  const download = () => {
    if (!blobUrl) return;
    const a = document.createElement("a");
    a.href = blobUrl;
    a.download = `Propuesta-KWSOLAR-${Date.now()}.pdf`;
    a.click();
  };

  /* si alguien entra directo sin state → vuelve al wizard */
  if (!state?.data) {
    navigate("/cotizar", { replace: true });
    return null;
  }

  return (
    <Box sx={{ maxWidth: 1100, mx: "auto", py: 8, px: 2 }}>
      {/* ---- instancia oculta para html2pdf ---- */}
      <div style={{ position: "absolute", left: -9999, top: -9999 }}>
        <QuotePdf ref={htmlRef} data={state.data} hideButton />
      </div>

      {/* ---- visor ---- */}
      {blobUrl ? (
        <iframe
          title="preview-pdf"
          src={blobUrl}
          className="w-full border rounded-xl shadow-lg"
          style={{ minHeight: "90vh" }}
        />
      ) : (
        <Box sx={{ display: "flex", justifyContent: "center", py: 20 }}>
          <CircularProgress />
        </Box>
      )}

      {/* ---- acciones ---- */}
      <Stack
        direction={{ xs: "column", sm: "row" }}
        spacing={2}
        justifyContent="flex-end"
        mt={4}
      >
        <Button onClick={() => navigate(-1)}>Volver</Button>
        <Button variant="contained" onClick={download}>
          Descargar PDF
        </Button>
      </Stack>
    </Box>
  );
}
